var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightGraphicArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 302,
    viewBox: "0 0 321 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53959 218.106C58.2473 143.238 121.481 125.907 164.619 158.316C209.542 192.066 134.159 236.55 116.932 194.183C99.7044 151.816 146.73 117.469 184.471 98.3148C206.037 87.3696 247.276 75.1246 304.776 89.8535",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.956 93.0058L309.649 92.0885C310.201 91.1161 310.201 91.1161 310.059 90.0071C308.978 88.6452 307.201 86.7619 306.3 85.3035C306.133 85.0122 305.293 84.1096 304.633 83.269C304.071 82.5526 304.691 81.1859 305.404 81.7525C307.177 83.3208 308.957 84.9732 310.563 86.806C311.704 88.1637 313.375 90.7015 313.11 91.9007C312.888 92.9054 310.285 94.5898 308.888 94.9374L308.888 94.9375C306.759 95.4189 304.63 95.9002 302.495 96.2976C301.719 96.5042 301.581 95.8879 302.264 95.4663C303.622 94.5306 305.699 94.1581 307.956 93.0058Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGraphicArrow);
export default __webpack_public_path__ + "static/media/right-graphic-arrow.f244d34a.svg";
export { ForwardRef as ReactComponent };